var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-tabbar"},[_c('div',{staticClass:"layout-tabbar-content"},_vm._l((_vm.tabbar),function(v,i){return _c('a',{key:i,class:['item', {'active': _vm.$route.meta.tabId == i}],on:{"click":function($event){return _vm.handleTapSwitch(v, i)}}},[_c('i',{staticClass:"icon",class:v.icon}),_c('span',[_vm._v(_vm._s(v.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }